import { mdiLock } from "@mdi/js";
import Icon from "@mdi/react";

export const Lock = ({ ...other }) => (
  <Icon style={{ position: "relative", bottom: 1 }} path={mdiLock} size="14px" {...other} />
);
